import { atom, useAtomValue, useSetAtom } from 'jotai';
import { isFeatureEnabled } from '../../utils/features';

export type VersionColorMode = 'diff' | 'collaborators' | 'full';

const versionColorModeAtom = atom<VersionColorMode>('diff');

const VERSION_COLOR_MODE_FEATURE_FLAG = 'feature_versionColorMode';

export const isVersionColorModeFeatureEnabled = () =>
  localStorage.getItem(VERSION_COLOR_MODE_FEATURE_FLAG) === 'true';

if (isFeatureEnabled('devtools')) {
  window.__slab.DEVTOOLS.toggleColorModeFeatureFlag = () => {
    if (isVersionColorModeFeatureEnabled()) {
      localStorage.removeItem(VERSION_COLOR_MODE_FEATURE_FLAG);
    } else {
      localStorage.setItem(VERSION_COLOR_MODE_FEATURE_FLAG, 'true');
    }
  };
}

export const useSetVersionColorMode = () => useSetAtom(versionColorModeAtom);
export const useVersionColorMode = () => useAtomValue(versionColorModeAtom);
